var map = {
	"./alerta.svg": 194,
	"./autonomo.svg": 616,
	"./buscar.svg": 419,
	"./cerrar.svg": 319,
	"./correo.svg": 310,
	"./costura.svg": 292,
	"./deportivos.svg": 823,
	"./electronicos.svg": 31,
	"./filtro.svg": 202,
	"./guarañar.svg": 904,
	"./hogar.svg": 623,
	"./jardineria.svg": 765,
	"./limpieza.svg": 889,
	"./manicura.svg": 699,
	"./otros.svg": 246,
	"./pintar.svg": 462,
	"./prendaVestir.svg": 670,
	"./telefono.svg": 442,
	"./x.svg": 489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 996;